import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	role: "img",
	width: 250,
	height: 160,
	"aria-labelledby": "loading-aria",
	viewBox: "0 0 250 160",
	preserveAspectRatio: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", {
			id: "loading-aria",
			children: "Loading..."
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: "100%",
			height: "100%",
			clipPath: "url(#clip-path)",
			style: { fill: "url(\"#fill\")" }
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("clipPath", {
			id: "clip-path",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 52,
					y: 61,
					rx: 3,
					ry: 3,
					width: 88,
					height: 14
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 53,
					y: 82,
					rx: 3,
					ry: 3,
					width: 52,
					height: 7
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 4,
					y: 10,
					rx: 3,
					ry: 3,
					width: 189,
					height: 13
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 24,
					cy: 71,
					r: 20
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 51,
					y: 123,
					rx: 3,
					ry: 3,
					width: 88,
					height: 14
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 52,
					y: 144,
					rx: 3,
					ry: 3,
					width: 52,
					height: 7
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23,
					cy: 133,
					r: 20
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "fill",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .599964,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "-2; -2; 1",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1.59996,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "-1; -1; 2",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 2.59996,
					stopColor: "#28272a",
					stopOpacity: 1,
					children: /* @__PURE__ */ _jsx("animate", {
						attributeName: "offset",
						values: "0; 0; 3",
						keyTimes: "0; 0.25; 1",
						dur: "2s",
						repeatCount: "indefinite"
					})
				})
			]
		})] })
	]
});
export default SvgSearchSkeleton;
